export default "__VITE_ASSET__250aecd2__"